var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M13.8337 3.91707L3.91708 13.8337C3.90291 13.8479 3.89583 13.855 3.88166 13.8621C3.6125 13.6354 3.36458 13.3875 3.13791 13.1183C2.06125 11.8787 1.41666 10.2637 1.41666 8.49999C1.41666 4.58999 4.59 1.41666 8.5 1.41666C10.2637 1.41666 11.8787 2.06124 13.1183 3.13791C13.3875 3.36457 13.6354 3.61249 13.8621 3.88166C13.855 3.89582 13.8479 3.90291 13.8337 3.91707Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M15.5833 8.49999C15.5833 12.3887 12.3888 15.5833 8.5 15.5833C7.4375 15.5833 6.43167 15.3496 5.525 14.9246C5.08583 14.7192 5.00083 14.1312 5.34083 13.7842L13.7842 5.34083C14.1242 5.00083 14.7192 5.08583 14.9246 5.52499C15.3496 6.42458 15.5833 7.43749 15.5833 8.49999Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M15.4204 1.57957C15.2079 1.36707 14.8608 1.36707 14.6483 1.57957L1.57959 14.6554C1.36709 14.8679 1.36709 15.215 1.57959 15.4275C1.68584 15.5267 1.82042 15.5833 1.96209 15.5833C2.10375 15.5833 2.23834 15.5267 2.34459 15.4204L15.4204 2.34457C15.64 2.13207 15.64 1.79207 15.4204 1.57957Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }